import styled from 'styled-components';
import IconWrapperProps from './type';
import { Icons } from './icons';

export const IconWrapperStyled = styled.div<IconWrapperProps>`
  width: ${(props) => `${props.size}`};
  height: ${(props) => `${props.size}`};
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.color
      ? `
      background: ${props.color};
      mask-image: url(${Icons[props.name]});
      mask-repeat: no-repeat;
      mask-size: 100% 100%;
      mask-origin: content-box;
      mask-position: center center;
      `
      : `
      background-image: url(${Icons[props.name]});
      background-repeat: no-repeat;
      background-position: center center;
      `}
`;

export const WrapperStyled = styled.div<IconWrapperProps>`
  width: ${(props) => `${props.size}`};
  height: ${(props) => `${props.size}`};
`;
